import cross from "../../assets/cross.svg"
import download from "../../assets/valuer_amend_download.svg"
import {useEffect, useState} from "react";
import doc from "../../assets/account_circle.png"

const ValuerAmendFilePreview = (props) => {

    const filename = props.filename ? props.filename : ''
    const file_base64 = props.file_base64 ? props.file_base64 : ""
    const fileWidth = props.fileWidth
    const fileHeight = props.fileHeight
    const deleteActive = props.deleteActive
    const deleteFunction = props.deleteFunction
    const fileIndex = props.fileIndex

    const [displayedImage, setDisplayedImage] = useState(doc)

    // Error Handling
    const setErrorMessage = props.setErrorMessage
    const setErrorTitle = props.setErrorTitle

    const [showDeletePopup, setDeletePopup] = useState();

    const DownloadFile = () => {
        if (!file_base64 || !filename) {
            setErrorTitle("Downloading Error")
            setErrorMessage("There was an error downloading the file")
        }
        const url = file_base64;
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
    }

    const DeleteFile = () => {
        if (!fileIndex && fileIndex !== 0) return
        deleteFunction(fileIndex)
    }

    const handleDeleteDialog = (res) => {
        if (res === "1") {
            setDeletePopup(false)
        } else if (res === "2") {
            DeleteFile()
            setDeletePopup(false)
        }
    }

    useEffect(() => {
        let _position = file_base64.search("data:image");
        if (_position !== -1) setDisplayedImage(file_base64)
    }, [file_base64]);

    return (
        <div className={"valuer-amend-file-preview-container" + (filename && displayedImage ? ' file' : ' no-file')}
             style={{width: fileWidth, height: fileHeight}}>
            {filename && displayedImage ?
                <>
                    <div className="valuer-amend-thumbnail-file-preview">
                        <img src={displayedImage} alt="valuer_image"/>
                        <div className="valuer-amend-file-download-button link" onClick={() => DownloadFile()}
                             style={{left: fileWidth.slice(0, 3) < 150 ? 115 : null, bottom: fileWidth.slice(0, 3) < 150 ? 77 : null}}>
                            <img src={download} alt="download" className="valuer-amend-file-download-image"/>
                        </div>
                    </div>
                    <div className="valuer-amend-field-preview-label-container">
                        <div className="valuer-amend-field-preview-label-text">
                            {filename.substring(0, Math.min(12, filename.length)) + (filename.length > 12 ? '...' + filename.split('.').slice(-1)[0] : '')}
                        </div>
                        {deleteActive && deleteActive
                            ?
                            <div className="valuer-amend-field-preview-delete-button link" onClick={() => setDeletePopup(true)}>
                                <img src={cross} alt="delete" className="valuer-amend-field-preview-delete-button-image"/>
                            </div>
                            :
                            null
                        }
                    </div>
                </>
                :
                    <div className="valuer-amend-file-no-image-text">
                        no image
                    </div>
            }
            {showDeletePopup ?
                <>
                    <div className="page-mask" onClick={() => handleDeleteDialog("1")}/>
                    <div className="valuer-amend-delete-popup-container">
                        <div className="valuer-amend-popup-title">Are you sure you want to delete this image?</div>
                        <div className="valuer-amend-popup-description">You cannot undo this action</div>
                        <div className="valuer-amend-popup-buttons-container">
                            <div className="valuer-amend-popup-button" onClick={() => handleDeleteDialog("1")}>Cancel</div>
                            <div className="valuer-amend-popup-button dark" onClick={() => handleDeleteDialog("2")}>Yes</div>
                        </div>
                    </div>
                </>
                :null}
        </div>

    )
}

export default ValuerAmendFilePreview